(function () {
    window.onscroll = stickyMenu;

    const navbar = document.querySelector('.header__nav')

    const sticky = navbar.offsetTop;

    function stickyMenu() {
        if (window.pageYOffset >= sticky) {
            document.querySelector('.header__nav--pox-clear').style.height = navbar.clientHeight + "px"
            navbar.classList.add("header__nav--sticky");

        } else {
            document.querySelector('.header__nav--pox-clear').style.height = "0"
            navbar.classList.remove("header__nav--sticky");
        }
    }
})();